import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { NotificationContainer } from 'react-notifications';
import { useLangContext } from "./context/languageContext";
import Auth from "./protectedRouter/Auth";
import CommonLayout from "./layout/commonLayout";
import "./App.css";
import 'react-notifications/lib/notifications.css';
import "bootstrap/dist/css/bootstrap.min.css";

//MainNav
import Home from "./pages/Home/Home";
import BusinessAddressProductPage from "./pages/BusinessAddress/ProductPage";
import ProduktTelefonnummer from "./pages/Produkt/Telefonnummer";
import ServiceTax from "./pages/Service/Tax";
import ServiceIncorporation from "./pages/Service/Incorporation";
import LocationList from "./pages/Location/List";
import Dubai from "./pages/Dubai/Dubai";
import Rooms from "./pages/Rooms/Rooms";
import Blog from "./pages/Blog/List";
import BlogDeatils from './pages/Blog/Deatils';
import Pricing from "./pages/Pricing/Pricing";
import Danke from "./pages/Thanks/Thanks";
import AboutUs from './pages/AboutUs/AboutUs';

//FooterNav
//Home
//LocationList
//PricingMailbox
//AboutUs
import Contact from './pages/Contact/Contact';
import Terms from "./pages/Legal/Terms";
import Privacy from "./pages/Legal/Privacy";
import Imprint from "./pages/Legal/Imprint";




import BusinessAddressDetail from "./pages/BusinessAddress/Detail"
import FAQ from "./pages/FAQ/FAQ";
import Error from "./pages/404/Error";
import PayPalComponent from "./pages/PaymentPages/PayPalComponent";
import NewMailView from "./pages/mail-view/NewMailView";
import Conditions from "./pages/accept-condition/Conditions";
import PurchasedPhoneNumber from "./pages/purchased-phone/PurchasedPhoneNumber";
import RenewPayment from "./pages/renew-payment/RenewPayment";
import AccountSetUp from "./pages/student/AccountSetUp";
import AccountDetails from "./pages/student/AccountDetails";
import StudentDashboard from "./pages/student/StudentDashboard";
import StudentProfile from "./pages/student/StudentProfile";
import LetStarted from "./pages/let-started/LetStarted";
import SelectProduct from "./pages/select-product/SelectProduct";
import SelectCountryPhoneNumber from "./pages/selectcountry-phonenumber/SelectCountryPhoneNumber";
import YourDetails from "./pages/your-details/YourDetails";
import Payment from "./pages/payment/Payment";
import MailBox from "./pages/mail-box/MailBox";
import Dashboard from "./pages/dashboard/Dashboard";
import NewAddress from "./pages/new-address/NewAddress";
import EnvelopScan from "./pages/envelop-scan/EnvelopScan";
import Scans from "./pages/scans/Scans";
import MyRequest from "./pages/my-request/MyRequest";
import Trashed from "./pages/trashed/Trashed";
import AccountSettings from "./pages/account-settings/AccountSettings";
import CurrentPlan from "./pages/current-plan/CurrentPlan";
import PlanUpgrade from "./pages/plan-upgrade/PlanUpgrade";
import ScanPayment from "./pages/scan-payment/ScanPayment";
import MailView from './pages/mail-view/MailView';
import AllMail from "./pages/all-mail/AllMail";
import InvoicesPayments from "./pages/invoices-payments/InvoicesPayments";
import NotLoginAuth from "./protectedRouter/NotLoginAuth";
import StudentPortal from "./pages/student/StudentPortal";
import ForgotPassword from './pages/Account/ForgotPassword';
import ResetPassword from './pages/Account/ResetPassword';
import Login from "./pages/Account/Login";
import Register from "./pages/Account/Registration";
import OrderMailbox from "./pages/order/OrderMailbox";
import OrderPhone from "./pages/order/OrderPhone";
import Layout from "./layout/Layout";
import UniversalRedirect from "./utils/UniversalRedirect";

function App() {
  const { setHostLanguage } = useLangContext();

  useEffect(()=>{
    if((window.location.hostname.endsWith('.de')) || window.location.hostname.endsWith('.ch'))
    {
      setHostLanguage('de');
    }
    else if(window.location.hostname.endsWith('.com'))
    {
      setHostLanguage('en');
    }else{
      setHostLanguage('de');
    }
  },[setHostLanguage])

  return (
    <>
      <Routes>
        <Route element={<Layout/>}>
          <Route path="/" element={<Home/>} />

          <Route path="/geschaeftsadresse" element={<BusinessAddressProductPage/>} />
          <Route path="/geschaeftsadresse/:name" element={<BusinessAddressDetail />} />
          <Route path="/telefonnummer" element={<ProduktTelefonnummer/>} />

          <Route path="/leistungen/steuer-und-buchhaltungsservice" element={<ServiceTax/>} />
          <Route path="/leistungen/gruendungsservice" element={<ServiceIncorporation/>} />

          <Route path="/standorte" element={<LocationList link="/standorte"/>} />
          <Route path="/standorte/:product" element={<LocationList link="/standorte"/>} />
          <Route path="/standorte/:product/:country" element={<LocationList link="/standorte"/>} />

          <Route path="/dubai" element={<Dubai />} />

          <Route path="/raeume" element={<Rooms link="/raeume"/>} />
          <Route path="/raeume/:country" element={<Rooms link="/raeume"/>} />

          <Route path="/blog" element={<Blog/>} />
          <Route path="/blog/entry/:id" element={<BlogDeatils/>} />
          <Route path="/preise" element={<Pricing link="/preise" />} />

          <Route path="/preise/geschaeftsadresse" element={<Pricing link="/preise" tab="geschaeftsadresse"/>} />
          <Route path="/preise/geschaeftsadresse/:country" element={<Pricing link="/preise" tab="geschaeftsadresse"/>} />
          <Route path="/preise/geschaeftsadresse/:country/:city" element={<Pricing link="/preise" tab="geschaeftsadresse"/>} />
          <Route path="/preise/geschaeftsadresse/:country/:city/:type" element={<Pricing link="/preise" tab="geschaeftsadresse"/>} />
          <Route path="/preise/telefonnummer" element={<Pricing link="/preise" tab="telefonnummer" />} />
          <Route path="/preise/telefonnummer/:country" element={<Pricing link="/preise" tab="telefonnummer" />} />
          <Route path="/preise/telefonnummer/:country/:area" element={<Pricing link="/preise" tab="telefonnummer" />} />
          <Route path="/danke" element={<Danke />} />

          <Route path="/ueber-uns" element={<AboutUs />} />
          
          {/* Footer */}
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/terms" element={<Terms/>} />
          <Route path="/privacy" element={<Privacy/>} />
          <Route path="/imprint" element={<Imprint/>} />

          {/* Subpages */}
          <Route path="/faq" element={<FAQ/>} />

          <Route path="/bestellen" element={<Pricing link="/bestellen" />} />
          <Route path="/bestellen/geschaeftsadresse" element={<Pricing link="/bestellen" tab="geschaeftsadresse"/>} />
          <Route path="/bestellen/geschaeftsadresse/:country" element={<Pricing link="/bestellen" tab="geschaeftsadresse"/>} />
          <Route path="/bestellen/geschaeftsadresse/:country/:city" element={<Pricing link="/bestellen" tab="geschaeftsadresse"/>} />
          <Route path="/bestellen/geschaeftsadresse/:country/:city/:type" element={<Pricing link="/bestellen" tab="geschaeftsadresse"/>} />
          <Route path="/bestellen/telefonnummer" element={<Pricing link="/bestellen" tab="telefonnummer" />} />
          <Route path="/bestellen/telefonnummer/:country" element={<Pricing link="/bestellen" tab="telefonnummer" />} />
          <Route path="/bestellen/telefonnummer/:country/:area" element={<Pricing link="/bestellen" tab="telefonnummer" />} />
        </Route>


        <Route path="/Order/Mailbox" element={<OrderMailbox />} />
        <Route path="/Order/Mailbox/:country" element={<OrderMailbox />} />
        <Route path="/Order/Mailbox/:country/:city" element={<OrderMailbox />} />
        <Route path="/Order/Mailbox/:country/:city/:type" element={<OrderMailbox />} />
        <Route path="/Order/Phone" element={<OrderPhone />} />
        <Route path="/Order/Phone/:country" element={<OrderPhone />} />
        <Route path="/Order/Phone/:country/:area" element={<OrderPhone />} />

        <Route path="/student-portal" element={<StudentPortal/>} />
        <Route path="/cond-test" element={<Conditions />} />




        <Route element={<NotLoginAuth/>}>
          <Route path="/register" element={<Register />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route exact path='/reset-password/:id' element={<ResetPassword />} />
        </Route>

        {/* <Route element={<Auth/>}> */}
        <Route element={<Auth allowedRoles={['client']}/>}>
          <Route path="/LetStarted" element={<LetStarted />} />
          <Route path="/SelectProduct" element={<SelectProduct />} />
          <Route path="/YourDetails" element={<YourDetails />} />
          <Route path="/SelectCountryPhoneNumber" element={<SelectCountryPhoneNumber />}/>
          <Route path="/Payment" element={<Payment />} />

          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/NewAddress" element={<NewAddress />} />
          <Route path="/AccountSettings" element={<AccountSettings />} />
          <Route path="/CurrentPlan" element={<CurrentPlan/>} />
          <Route path="/PlanUpgrade" element={<PlanUpgrade />} />
          <Route path="/MailView" element={<MailView />} />
          <Route path="/NewMailView" element={<NewMailView/>} />
          <Route path='/scan-payment' element={<ScanPayment/>} />
          <Route path='/renew-payment' element={<RenewPayment/>} />

          <Route element={<CommonLayout/>}>
            <Route path="/AllMail" element={<AllMail />} />
            <Route path="/MailBox" element={<MailBox />} />
            <Route path="/EnvelopScan" element={<EnvelopScan />} />
            <Route path="/Scans" element={<Scans />} />
            <Route path="/MyRequest" element={<MyRequest />} />
            <Route path="/Trashed" element={<Trashed />} />
            <Route path="/InvoicesPayments" element={<InvoicesPayments />} />
            <Route path="/purchased-phone-number" element={<PurchasedPhoneNumber />} />
          </Route>
        
        </Route>


        <Route element={<Auth allowedRoles={['student']}/>}>
          <Route path="/student-account-set-up" element={<AccountSetUp />} />
          <Route path="/student-account-details" element={<AccountDetails />} />
          <Route path= "/student-dashboard" element={<StudentDashboard />}/>
          <Route path= "/student-profile" element={<StudentProfile />}/>
        </Route>

        <Route path="/paypal" element={<PayPalComponent/>} />
        <Route path="*" element={<Error/>} />
      </Routes>
      <NotificationContainer/>
    </>
  );
}

export default App;
